/**
 * Returns the value as a normalised absolute URL when it parses as an
 * `http:` / `https:` URL, otherwise `null`.
 *
 * Relative paths (e.g. the '/' fallback used when an env var is unset),
 * malformed values (e.g. 'http-marketing.example') and other schemes
 * ('javascript:', 'mailto:') all return `null`, so callers can fall back to a
 * safe default. Scheme matching is case-insensitive via the URL parser.
 */
export function toAbsoluteHttpUrl(value: string | null | undefined): string | null {
  if (!value) return null;

  try {
    const url = new URL(value);
    return url.protocol === 'http:' || url.protocol === 'https:'
      ? url.href
      : null;
  } catch {
    return null;
  }
}
